import { Image } from "@chakra-ui/image";
import { Box, Flex, Text } from "@chakra-ui/layout";
import React, { useContext, useEffect, useRef, useState } from "react";
import { CanvasContext } from "../../Components/core/workspace/CanvasContext";
import { fabric } from "fabric";
import { LuImagePlus } from "react-icons/lu";
import axios from "axios";
import { TemplateData } from "../panels/data";
import { Button } from "@chakra-ui/react";

const Uploads = () => {
  const { canvas, canvasRef } = useContext(CanvasContext);
  const [image, setImage] = useState([]);
  const imageRef = useRef(null);
  const [page, setPage] = useState(0);
  const pageSize = 10;
  const [hasMoreData, setHasMoreData] = useState(true);

  const [temp, setTemp] = useState([]);
  console.log(`temp`, temp);
  const id = localStorage.getItem("source");
  const getTemplate = async () => {
    try {
      const response = await axios.get(
        `https://dev.api.wishfy.io/template/template-builder/by-source-media-id?sourceMediaId=${328}`,
      );
      if (response.status === 200) {
        setTemp(response.data.payload.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTemplate();
  }, []);
  const accessToken = localStorage.getItem("token");
  const hangleImageChange = (event) => {
    const file = event.target.files[0];
    console.log("file", file);
  };
  const addImg = (url) => {
    if (canvas) {
      const json = JSON.stringify(TemplateData).replace(
        "https://wishfy-web.wishfy.io/media/public/2023/09/09/18/20230909182557021_wIshFy_bc6cbebf1e4c4c0cb766a784cba28e5c.png",
        url,
      );
      canvas.loadFromJSON(json);
      canvas.renderAll();
    }
  };
  const getList = async () => {
    try {
      const response = await axios.get(
        `https://dev.api.wishfy.io/media/media/file/admin/get/byuserandimagegroup?imageGroup=USER_CARD_IMAGES&page=${page}&pageSize=${pageSize}`,
        {
          headers: {
            "Content-Type": "applications/json",
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
      if (response.status === 200) {
        const newData = response.data;
        setImage((prevImages) => [...prevImages, ...response.data]);
        if (newData.length < pageSize) {
          setHasMoreData(false);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getList();
  }, [page]);

  const handleViewMore = () => {
    setPage(page + 1);
  };
  return (
    <Box bg="#F1F1F1" h={"full"} pt={5}>
      <Text fontWeight={"semibold"} textDecoration={"underline"} mb={2}>
        All Uploaded Images
      </Text>
      <Box display={"grid"} gridTemplateColumns={"repeat(2,100px)"} gap={3}>
        {image &&
          image.map((el, i) => (
            <Image
              src={el.imageUrl}
              h={24}
              borderRadius={10}
              w={"full"}
              key={i}
              onClick={() => addImg(el.imageUrl)}
            />
          ))}
      </Box>
      {hasMoreData ? (
        <Button onClick={handleViewMore} colorScheme="blue">
          View More
        </Button>
      ) : (
        <p>No more data</p>
      )}
    </Box>
  );
};

export default Uploads;
